export const enum PaymentType {
  Boleto = 'bankBilling',
  Pix = 'pix',
}

export type PaymentTitleType = {
  amount: number;
  brand?: string;
  daysLate: number;
  daysUntilDueDate: number;
  dueDate: string;
  orderId: string;
  paymentStatus: string;
  paymentTitleId: string;
  paymentType: string;
  plan: string;
  planDetail: string;
  planType: string;
  status: string;
  totalBalance: number;
};

export type PaymentListType = {
  data: PaymentTitleType[];
  pagination: {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalSize: number;
  };
  success: boolean;
};
export type PaymentDetail = {
  amount: number;
  barCode: string;
  daysLate: number;
  daysUntilDueDate: number;
  dueDate: string;
  fileLink: string;
  installment: number;
  installmentQty: number;
  issueDate: string;
  orderId: string;
  paidAmount: number;
  paymentStatus: string;
  paymentTitleId: string;
  paymentType: string;
  plan: string;
  planType: string;
  planDetail: string;
  status: string;
  totalBalance: number;
};

export type PaymentDetailType = {
  success: boolean;
  data: PaymentDetail;
};
